//
// Javascript for the HEI DevExpress Gridview
//
//  Drew McMinn
//
$(document).ready(function () { new HEIJS.Controls.HEIGridView(); });

HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.HEIGridView = function (inputs)
{
  $('.hei-gridview-export-wrapper').each(function(){
	var grid = $(this).next('.hei-gridview');
	if (grid && grid.length > 0) $(this).insertAfter(grid).show();
  });
};